<template>
  <div class="count-down-card">
    <div v-if="days || days === 0" class="counter-card">
      <span class="time-value">{{ days }}</span>
      <span class="time-unit">dias</span>
    </div>

    <span class="time-divider">:</span>

    <div v-if="hours || hours === 0" class="counter-card">
      <span class="time-value">{{ hours }}</span>
      <span class="time-unit">hors</span>
    </div>

    <span class="time-divider">:</span>

    <div v-if="minutes || minutes === 0" class="counter-card">
      <span class="time-value">{{ minutes }}</span>
      <span class="time-unit">mins</span>
    </div>

    <span class="time-divider">:</span>

    <div v-if="seconds || seconds === 0" class="counter-card">
      <span class="time-value">{{ seconds }}</span>
      <span class="time-unit">segs</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CountDownCard',
  props: {
    days: { type: Number, required: false, default: undefined },
    hours: { type: Number, required: false, default: undefined },
    minutes: { type: Number, required: false, default: undefined },
    seconds: { type: Number, required: false, default: undefined }
  }
}
</script>

<style lang="scss" scoped>
@import 'assets/scss/variables';

.count-down-card {
  display: flex;
  align-items: center;

  .time-divider {
    @include HeadingXSmall;
    color: $neutral500;

    padding: 0 10px;
  }

  .counter-card {
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: $neutral100;
    padding: 8px;
    border-radius: 4px;
    gap: 4px;
    width: 48px;
    color: $neutral500;

    .time-value {
      @include HeadingXSmall;
      font-family: $monserratFontFamily;
    }

    .time-unit {
      @include ParagraphXSmall;
      font-family: $monserratFontFamily;
    }
  }
}
</style>
